<template>
  <div class="energy-trends">
    <div class="energy-trends-title">制冷用能预测</div>
    <div class="energy-trends-condition">
      <div class="item">
        <div class="title" style="font-size: 16px; font-weight: 600;">预测用能：{{ forecast.toFixed(2) }} kwh</div>
      </div>
      <div class="item">
        <span class="title">制冷机组</span>
        <el-select v-model="buildingId" :clearable="clearableFlag" placeholder="请选择" style="width: 70%;"
          @change="queryTodayConsumption">
          <el-option v-for="item in buildingOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span class="title">类型</span>
        <el-select v-model="type" :clearable="clearableFlag" placeholder="请选择" style="width: 70%;"
          @change="queryTodayConsumption">
          <el-option v-for="item in typeArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="energy-trends-charts">
      <div id="energyForecastChart" style="width: 100%; height: 12rem"></div>
    </div>
  </div>
</template>

<script>
import { api } from '../api/api'
import eCharts from "echarts"
export default {
  data() {
    return {
      buildingId: 8,
      buildingOpts: [{ 'label': '1号冷库制冷机组', 'value': 8 }, { 'label': '5号冷库制冷机组', 'value': 9 }],
      energyForecastChart: null,
      energyForecastChartOpt: null,
      forecast: 0,
      type: '2',
      typeArr: [{ 'label': '日', 'value': '1' }, { 'label': '月', 'value': '2' }],
      xData: [],
      yData: [],
      clearableFlag: false
    }
  },
  mounted() {
    this.queryTodayConsumption()
    window.onresize = () => {
      this.energyForecastChart.resize()
    };
  },
  methods: {
    async queryTodayConsumption() {
      this.xData = []
      this.yData = []
      this.forecast = 0
      const {
        success,
        returnObj
      } = await this.$fetch(api.monthBuildenergyPrediction + '?buildId=' + this.buildingId + '&dateType=' + this.type)
      if (success && returnObj.length > 0) {
        for (let i = 0; i < returnObj.length; i++) {
          this.xData.push(returnObj[i].keyX)
          this.yData.push(returnObj[i].dataY)
          this.forecast += Number(returnObj[i].dataY)
        }
        this.initBuildingPowerChart();
      }
    },
    initBuildingPowerChart() {
      let chartDom = document.getElementById("energyForecastChart");
      this.energyForecastChart = eCharts.init(chartDom);
      this.energyForecastChartOpt = {
        color: ['#00BFFF'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: "rect",
          itemHeight: 12,
          itemWidth: 25,
          right: 40,
          top: 10
        },
        grid: {
          left: '1%',
          right: '5%',
          bottom: '8%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          name: '日',
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          },
          // axisLabel: {
          //   interval: 0,//横轴信息全部显示
          //   rotate: -50,// -20度角倾斜显示
          // },
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          name: "单位：kwh",
        },
        series: [
          {
            type: 'line',
            smooth: true,
            // stack: 'Total',
            data: this.yData
          }
        ]
      };
      this.energyForecastChart.setOption(this.energyForecastChartOpt);
    },
  }
}
</script>

<style lang="scss" scoped>
.energy-trends {
  width: 100%;
  height: 100%;
}

.energy-trends-title {
  margin: 15px 0 0 10px;
  font-size: 16px;
  font-weight: bold;
}

.energy-trends-condition {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;

  .item {
    margin-right: 10px;

    .title {
      margin-right: 10px;
    }
  }
}
</style>